import axios from 'axios';
import TokenService from './TokenService';

const Axios = axios.create({
  baseURL: 'https://api.weeamici.com',
  headers: {
    'Content-Type': 'application/json',
  },
});

Axios.interceptors.request.use(async (config) => {
  const { accessToken, idToken } = await TokenService.getTokens();

  config.headers.Authorization = `Bearer ${accessToken}`;
  config.headers["x-id-token"] = `Bearer ${idToken}`;

  return config;
});

Axios.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;

    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;

      // The server rejected the token, so don't let Amplify hand back the
      // cached one because the client clock thinks it's still good.
      const tokens = await TokenService.refreshTokens(true);

      original.headers.Authorization = `Bearer ${tokens.accessToken}`;
      original.headers["x-id-token"] = `Bearer ${tokens.idToken}`;

      return Axios(original);
    }

    return Promise.reject(error);
  }
);


export default Axios;
